var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.767 18.939c-.268 1.607-.111 8.71 0 12.06l-4.69-9.65V10.63c-.134-.402-.188-1.97.67-5.026 1.072-3.82 4.824-5.226 8.51-4.355 2.948.696 4.49 4.756 4.891 6.7v13.4l-4.456 9.483-.335-11.894-.502-3.486a25.43 25.43 0 0 1 2.915-1.608c1.366-.643 1.396-2.144 1.24-2.814-.961.402-3.056 1.286-3.753 1.608-.871.402-.905.67-.905 1.407 0 .737.57 3.686-.234 4.49-.805.804-1.408.737-2.145 0s0-3.418 0-4.49c0-1.072-.402-1.005-1.206-1.407-.643-.322-2.68-1.206-3.618-1.608.043.849.468 2.64 1.808 3.015 1.34.375 2.3 1.095 2.613 1.407-.155.492-.535 1.877-.803 3.485z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparta);
export default __webpack_public_path__ + "static/media/SPARTA.73bc3a65c72684cee08753825c22d758.svg";
export { ForwardRef as ReactComponent };